// extracted by mini-css-extract-plugin
export default {"modalContainer":"ConfirmationDialog_modalContainer__JqSys","textContainer":"ConfirmationDialog_textContainer__iekn5","actionsContainer":"ConfirmationDialog_actionsContainer__K9fS5"};